import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";




const firebaseConfig = {
  apiKey: "AIzaSyDb8a5K5j0mVd-TYDPTmzMSgnG4N5BZE3k",
  authDomain: "ecudriver-30c0a.firebaseapp.com",
  projectId: "ecudriver-30c0a",
  storageBucket: "ecudriver-30c0a.appspot.com",
  messagingSenderId: "330863053095",
  appId: "1:330863053095:web:d5f2e1610f05c1d7f14102",
  measurementId: "G-CMX81HN36W"
};



const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
